import { InsuranceProductsTableFields } from './enums'

export const insuranceProductTableHeaderTitles: Record<InsuranceProductsTableFields, string> = {
  [InsuranceProductsTableFields.id]: 'ID',
  [InsuranceProductsTableFields.name]: 'Name',
  [InsuranceProductsTableFields.description]: 'Description',
  [InsuranceProductsTableFields.createdAt]: 'Date created',
  // The actions column is buttons only; a header would just add noise.
  [InsuranceProductsTableFields.actions]: '',
}

// A global catalog of a handful of rows, so this stops at 100. The customers list carries
// 500/1000 only because of an explicit product request recorded alongside it.
export const insuranceProductPageSizeOptions = [25, 50, 100]

export const INSURANCE_PRODUCTS_GRID_COLUMNS_STORAGE_KEY = 'admin.insuranceProducts.gridColumns'
